<template>
  <div class="cases-table">
    <el-button @click="batchSendSMS" size="mini">批量发送短信</el-button>
    <el-table
      :data="paramsList"
      header-row-class-name="table"
      @selection-change="val => (selection = val)"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        v-for="(item, index) in columns"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
      >
      </el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="queryDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const baseData = {
  selection: []
};

const list = [{ caseId: 1001, date: "test" }];

// 案件ID 订单编号 逾期类型 用户姓名 手机号 逾期金额 逾期天数 事件状态 跟进人 入催时间
const columns = Object.freeze([
  { prop: "order_id", label: "案件ID", width: "150" },
  { prop: "order_no", label: "订单编号", width: "150" },
  // { prop: "date", label: "逾期类型", width: "150" },
  { prop: "username", label: "用户姓名", width: "150" },
  { prop: "mobile", label: "手机号", width: "150" },
  { prop: "price", label: "逾期金额", width: "150" },
  // { prop: "date", label: "逾期天数", width: "150" },
  { prop: "event_status", label: "事件状态", width: "150" },
  { prop: "create_time", label: "入催时间", width: "150" },
  // { prop: "date", label: "分配时间", width: "150" },
  { prop: "update_time", label: "最近跟进时间", width: "150" }
]);

const methods = {};
methods.batchSendSMS = function() {
  if (this.selection.length === 0)
    return this.$message.error("请选择要发送短信的案件");
  this.$emit("openModel");
  return;
};

methods.queryDetail = function(row) {
  return this.$router.push({
    path: "/collection/manage/index",
    query: { id: row.id }
  });
};

const options = {
  name: "CasesTable",
  props: ["paramsList"],
  // watch: {
  //   // 监听 paramsList 的变化
  //   paramsList: {
  //     handler(newValue, oldValue) {
  //       console.log("paramsList changed:",oldValue, newValue);
  //     },
  //     deep: true,
  //     immediate: false
  //   }
  // },
  data() {
    return { columns, list, ...baseData };
  },
  methods,
  created() {}
};

export default options;
</script>

<style lang="scss" scoped>
.cases-table {
  padding: 0 20px;

  .table {
    // background-color: azure;
    color: azure;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/collection/collection_cases/component/CasesTable.vue